import type { BatchData } from '../types';
import MetaField from './MetaField';

interface Props {
  data: BatchData;
  onPatch: (patch: Partial<BatchData>) => void;
  onFocusField: (fieldId: string | null) => void;
}

export default function BatchIdentityCard({ data, onPatch, onFocusField }: Props) {
  return (
    <div className="card">
      <div className="card-header">
        <span className="card-title">Batch Identity</span>
      </div>
      <div className="card-body">
        <div className="field-grid fg-4">
          <MetaField label="Batch ID" id="metaBatchId" placeholder="HH-001" data={data} onPatch={onPatch} onFocusField={onFocusField} />
          <MetaField label="Product name" id="metaProduct" placeholder="e.g. Aloe Facial Serum" data={data} onPatch={onPatch} onFocusField={onFocusField} />
          <MetaField label="Date" id="metaDate" type="date" data={data} onPatch={onPatch} onFocusField={onFocusField} />
          <MetaField label="Version" id="metaVersion" placeholder="v1.0" data={data} onPatch={onPatch} onFocusField={onFocusField} />
          <MetaField label="Formulator" id="metaFormulator" placeholder="Your name" data={data} onPatch={onPatch} onFocusField={onFocusField} />
          <MetaField label="Batch yield (g)" id="metaBatchYield" type="number" placeholder="100" data={data} onPatch={onPatch} onFocusField={onFocusField} />
          <MetaField label="Bottle size" id="metaBottleSize" placeholder="e.g. 30ml" data={data} onPatch={onPatch} onFocusField={onFocusField} />
          <MetaField label="Units" id="metaUnits" type="number" placeholder="# bottles" data={data} onPatch={onPatch} onFocusField={onFocusField} />
        </div>
      </div>
    </div>
  );
}
